import { Component, ElementRef, inject, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { DocumentItem, Invoice } from '../../../model/document.model';
import { CurrentUserService } from '../../../services/currentUser.service';
import { MessagingService } from '../../../components/messaging/messaging.service';
import { UserService } from '../../../services/user.service';
import { MatCard, MatCardContent } from '@angular/material/card';
import { HighlightStatusDirective } from '../../../directives/highlight-status.directive';
import { MatTooltip } from '@angular/material/tooltip';
import { PdfButtonComponent } from '../pdf-button/pdf-button.component';
import { DecimalPipe } from '@angular/common';
import { DatePipe } from '../../../pipes/date.pipe';
import { TimePipe } from '../../../pipes/time.pipe';

@Component({
  selector: 'app-partial-invoice',
  templateUrl: './partial-invoice.component.html',
  styleUrls: ['./partial-invoice.component.scss'],
  imports: [
    MatCard,
    MatCardContent,
    HighlightStatusDirective,
    MatTooltip,
    PdfButtonComponent,
    DecimalPipe,
    DatePipe,
    TimePipe
  ]
})
export class PartialInvoiceComponent implements OnInit, OnChanges {
  @Input() document: DocumentItem;
  @Input() repairerSiteId: number;
  @Input() shouldCollapseCurtain: boolean;
  @ViewChild('panel', { static: false }) panel: ElementRef;

  #currentUserService = inject(CurrentUserService);
  #message = inject(MessagingService);
  #userService = inject(UserService);

  invoice: Invoice;
  timezone: string;

  ngOnInit(): void {
    this.timezone = this.#currentUserService?.timeZone;
    this.invoice = this.document.document as Invoice;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.shouldCollapseCurtain && !changes.shouldCollapseCurtain.firstChange) {
      if (changes.shouldCollapseCurtain.currentValue) {
        this.panel.nativeElement.close();
      }
    }
  }

  openInvoiceReport(): void {
    this.#userService.getJobReport(`/jobs/${this.invoice.jobId}/reports/invoice/${this.invoice.id}`).subscribe({
      error: () => this.#message.error('There was an error loading the invoice PDF.')
    });
  }
}
